/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free_trial_day: NonNullable<unknown> }} Btn_Start_Free_Trial_DayInputs */

const en_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start My Free ${i?.free_trial_day} Days`)
};

const ar_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ابدأ أيامي المجانية ${i?.free_trial_day}`)
};

const de_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day} kostenlose Tage`)
};

const es_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empezar mis ${i?.free_trial_day} días gratis`)
};

const fr_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Démarrer mes ${i?.free_trial_day} jours gratuits`)
};

const it_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia i miei ${i?.free_trial_day} giorni gratuiti`)
};

const ja_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料の${i?.free_trial_day}日間を始める`)
};

const ko_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.free_trial_day}일 무료 체험 시작하기`)
};

const pt_br_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começar meus ${i?.free_trial_day} dias grátis`)
};

const ru_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начать ${i?.free_trial_day} бесплатных дней`)
};

const th_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มต้นใช้ ${i?.free_trial_day} วันฟรีของฉัน`)
};

const tr_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ücretsiz ${i?.free_trial_day} Günümü Başlat`)
};

const zh_cn_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始免费体验 ${i?.free_trial_day} 天`)
};

const zh_tw_btn_start_free_trial_day = /** @type {(inputs: Btn_Start_Free_Trial_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開始免費體驗 ${i?.free_trial_day} 天`)
};

/**
* | output |
* | --- |
* | "Start My Free {free_trial_day} Days" |
*
* @param {Btn_Start_Free_Trial_DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_start_free_trial_day = /** @type {((inputs: Btn_Start_Free_Trial_DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Start_Free_Trial_DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_start_free_trial_day(inputs)
	if (locale === "ar") return ar_btn_start_free_trial_day(inputs)
	if (locale === "de") return de_btn_start_free_trial_day(inputs)
	if (locale === "es") return es_btn_start_free_trial_day(inputs)
	if (locale === "fr") return fr_btn_start_free_trial_day(inputs)
	if (locale === "it") return it_btn_start_free_trial_day(inputs)
	if (locale === "ja") return ja_btn_start_free_trial_day(inputs)
	if (locale === "ko") return ko_btn_start_free_trial_day(inputs)
	if (locale === "pt_br") return pt_br_btn_start_free_trial_day(inputs)
	if (locale === "ru") return ru_btn_start_free_trial_day(inputs)
	if (locale === "th") return th_btn_start_free_trial_day(inputs)
	if (locale === "tr") return tr_btn_start_free_trial_day(inputs)
	if (locale === "zh_cn") return zh_cn_btn_start_free_trial_day(inputs)
	return zh_tw_btn_start_free_trial_day(inputs)
});